import initialState from './PlayerInitialState';
import reducers from './PlayerReducer';

export default {
  initialState,
  reducers,
};
